module.exports={
"header.industry.mall":`Industry Mall`,
"header.home":`Home`,
"header.solutions.apps":`Industry CRM`,
"header.learning.center":`Learning Center`,
"header.partner.portal":`Partner Portal`,
"header.pricing.plan":`Pricing Plan`,
"header.my.orders":`My Orders`,
"header.login.cloudcc":`Login CloudCC`,
"header.logout":`Logout`,
"header.login.industry.mall":`Login Industry Mall`,
"header.search":`Search`,
"header.congrats.formal.partner":`Congratulations! You are now a formal partner`,
"header.logout.success":`Logout successful`,
"footer.scan.follow":`Scan to follow our official account`,
"footer.quick.links":`Quick Links`,
"footer.why.cloudcc":`Why CloudCC`,
"footer.business.platform":`Business Platform`,
"footer.integration":`Integration`,
"footer.paas.platform":`PaaS Platform`,
"footer.case.center":`Case Center`,
"footer.data.security":`Data Security`,
"footer.gdpr.compliance":`GDPR Compliance`,
"footer.service.agreement":`Service Agreement`,
"footer.privacy.statement":`Privacy Statement`,
"footer.app.permissions":`App Permissions`,
"footer.products.prices":`Products & Prices`,
"footer.sales.cloud":`Sales Cloud`,
"footer.customer.service.cloud":`Service Cloud`,
"footer.field.service.cloud":`Field Service Cloud`,
"footer.marketing.cloud":`Marketing Cloud`,
"footer.partner.cloud":`Partner Cloud`,
"footer.project.cloud":`Project Cloud`,
"footer.social.cloud":`Social Cloud`,
"footer.platform.cloud":`Platform Cloud`,
"footer.mobile.terminal":`Mobile Terminal`,
"footer.versions.prices":`Versions & Prices`,
"footer.industry.solutions":`Industry Solutions`,
"footer.manufacturing":`Manufacturing`,
"footer.education.training":`Education & Training`,
"footer.it.hightech":`IT & High-tech`,
"footer.city.operation":`City Operation`,
"footer.finance.industry":`Finance Industry`,
"footer.medical.devices":`Medical Devices`,
"footer.tourism.industry":`Tourism Industry`,
"footer.legal.industry":`Legal Industry`,
"footer.service.support":`Service & Support`,
"footer.partners":`Partners`,
"footer.partner.support":`Partner Support`,
"footer.help.center":`Help Center`,
"footer.resource.center":`Resource Center`,
"resource.solutions.customer.service.cloud":`Service Cloud`,
"resource.solutions.field.service.cloud":`Field Service Cloud`,
"resource.solutions.project.cloud":`Project Cloud`,
"resource.solutions.partner.cloud":`Partner Cloud`,
"resource.solutions.business.cloud":`Business Cloud`,
"resource.solutions.profit.cloud":`Profit Cloud`,
"resource.solutions.platform.cloud":`Platform Cloud`,
"navigation.banner.ai.empower":`AI Empowered 1-Day Industry Solution CRM Creation`,
"navigation.banner.zero.tech.threshold":`Zero Technical Threshold`,
"navigation.banner.price.autonomy":`Price Autonomy`,
"navigation.banner.permanent.profit.sharing":`Permanent Profit Sharing`,
"navigation.banner.saas.entrepreneurship":`Start a New Era of SaaS Entrepreneurship`,
"navigation.banner.experience.now":`Experience Now`,
"home.install.stats":`A total of {0} industry solution products. Recently installed {1} times.`,
"home.stats.total":`Total`,
"home.stats.industry.products":`industry solution products. Total installations`,
"home.stats.times":`times.`,
"footer.about.us":`About Us`,
"footer.company.introduction":`Company Introduction`,
"footer.company.news":`Company News`,
"footer.management.team":`Management Team`,
"footer.corporate.culture":`Corporate Culture`,
"footer.development.history":`Development History`,
"footer.qualifications.honors":`Qualifications & Honors`,
"footer.brand.culture":`Brand Culture`,
"footer.join.cloudcc":`Join CloudCC`,
"footer.contact.us":`Contact Us`,
"footer.app.download":`APP Download`,
"footer.scan.qrcode":`Scan QR code to download mobile APP`,
"footer.enter.mobile.store":`Enter mobile store to download mobile APP`,
"footer.telecom.license":`Value-added Telecom Business License: Beijing B2-20170892`,
"footer.copyright":`© Copyright: Beijing Shenzhou Yundong Technology Co., Ltd.`,
"footer.developer":`Developer: Beijing Shenzhou Yundong Technology Co., Ltd. All rights reserved`,
"footer.icp.registration":`Beijing ICP No. 09016255`,
"footer.icp.certificate":`Beijing ICP Certificate 110683`,
"footer.public.security":`Beijing Public Network Security No. 110108008174`,
"agreement.license":`License Agreement`,
"agreement.i.agree":`I agree`,
"agreement.enterprise.agreement":`Enterprise (or Individual) CloudCC Marketplace Agreement`,
"agreement.i.agree.cloudcc":`I agree to CloudCC's`,
"agreement.privacy.policy":`Privacy Policy`,
"agreement.and":`and`,
"agreement.terms.of.service":`Terms of Service`,
"agreement.apply.partner":`Apply as Partner`,
"agreement.must.agree.license":`You must agree to the CloudCC License Agreement`,
"agreement.must.agree.enterprise":`You must agree to the Enterprise or Individual CloudCC Marketplace Agreement`,
"label.appstore.UntilMaturity.time":`Time remaining until expiration date`,
"label.appstore.list.payments":`Once you have purchased any of our products, your payment method will be listed here.`,
"label.appstore.duedate":`Due Date`,
"label.appstore.Pay":`Payment`,
"label.appstore.enterAddress":`Please enter your full address.`,
"label.appstore.country":`Country`,
"label.appstore.Update.profile":`Update Profile`,
"label.appstorePleaseEnter":`Please enter`,
"label.appstore.useremail":`User Email`,
"label.appstore.Enabled.quantity":`Number of activated`,
"label.appstore.Pay.gateway":`Safe and Secured Payment Gateway`,
"label.appstore.year":`Year`,
"label.appstore.Version.price":`Versions and Prices`,
"label.appstore.cancel":`Cancel`,
"label.appstore.selectMonth":`Please select the month.`,
"label.appstore.Change.new.address":`All your existing orders with this billing address will be changed to the new address.`,
"label.appstore.noAccess":`Possible reasons: The URL may be incorrect. Or, you might not have access.`,
"label.appstore.MonthlyAmount":`Amount per month`,
"label.appstore.TechnicalDetails":`Technical Details`,
"label.appstore.Please.enter.the.content":`Please enter content`,
"label.appstore.invoice":`Tax Invoice`,
"home.explore.hot.categories":`Explore Hot Categories`,
"home.use.appexchange":`Extend CloudCC with AppExchange`,
"home.appexchange.description":`AppExchange is the leading enterprise cloud marketplace with over 9,000 pre-built and customizable applications to extend your CloudCC digital workforce platform. It's a mature ecosystem with over 13 million installations and 157,000 user reviews, helping you find the best solutions for your unique business needs. Now, with AgentExchange, you can leverage the most suitable Agentforce partner solutions to quickly build AI agents.`,
"home.view.all":`View All`,
"message.no.data":`No data found`,
"message.load.failed":`Failed to load data`,
"message.no.more.data":`No more data`,
"applist.sponsored.solutions":`Recommended Industry Solutions`,
"applist.today.trends":`Latest Industry Solutions`,
"applist.view.more":`View More`,
"industry.education":`Education Industry`,
"industry.manufacturing":`Manufacturing Industry`,
"industry.it":`IT Industry`,
"industry.finance":`Finance Industry`,
"industry.medical":`Medical Industry`,
"resource.data.sheet":`Data Sheet`,
"resource.customer.review":`Customer Review`,
"resource.case.study":`Case Study`,
"resource.whitepaper":`Whitepaper`,
"resource.webinar":`Webinar`,
"resource.custom.guide":`Custom Guide`,
"resource.solutions.sales.cloud":`Sales Cloud`,
"resource.solutions.marketing.cloud":`Marketing Cloud`,
"resource.solutions.service.cloud":`Service Cloud`,
"resource.solutions.office.cloud":`Office Cloud`,
"resource.solutions.hr":`Human Resources`,
"resource.solutions.project.management":`Project Management`,
"resource.solutions.other":`Other`,
"resource.category.custom.component":`Custom Component`,
"resource.category.custom.class":`Custom Class`,
"resource.category.scheduled.class":`Scheduled Class`,
"resource.category.trigger":`Trigger`,
"resource.category.client.script":`Client Script`,
"resource.industry.automotive":`Automotive`,
"resource.industry.consumer.goods":`Consumer Goods`,
"resource.industry.communication":`Communication`,
"resource.industry.high.end.manufacturing":`High-end Manufacturing`,
"resource.industry.semiconductor":`Semiconductor Chips`,
"resource.industry.mechanical.equipment":`Mechanical Equipment`,
"resource.industry.heavy.manufacturing":`Heavy Manufacturing`,
"resource.industry.ai.computing":`AI & Computing Power`,
"resource.industry.internet":`Internet`,
"resource.industry.financial.investment":`Financial Investment`,
"resource.industry.financing.guarantee":`Financing Guarantee`,
"resource.industry.financial.leasing":`Financial Leasing`,
"resource.industry.insurance":`Insurance`,
"resource.industry.wealth.management":`Wealth Management`,
"resource.industry.medical.devices":`Medical Devices/IVD`,
"resource.industry.pharmaceutical":`Pharmaceutical`,
"resource.industry.health.elderly.care":`Health & Elderly Care`,
"resource.industry.medical.service.solution":`Medical Services`,
"resource.industry.education.training":`Education & Training`,
"resource.industry.k12":`K12`,
"resource.industry.energy.chemical":`Energy & Chemical`,
"resource.industry.nonferrous.metals":`Nonferrous Metals`,
"resource.industry.steel":`Steel`,
"resource.industry.park.real.estate":`Park & Real Estate`,
"resource.industry.lawyer":`Legal Services`,
"resource.industry.enterprise.service":`Enterprise Services`,
"resource.industry.media.tourism":`Media & Tourism`,
"resource.industry.other":`Other`,
"appdetail.price.per.month":`/person/month`,
"appdetail.apply.trial.portal":`Try Customer Portal`,
"appdetail.apply.trial":`Try It`,
"appdetail.apply.demo":`Book a Demo`,
"appdetail.buy.install":`Buy & Install`,
"appdetail.app.info":`Application Basic Information`,
"appdetail.feature.intro":`Feature Introduction`,
"appdetail.highlights":`Highlights`,
"appdetail.rating":`Rating`,
"appdetail.listing.time":`Listing Time`,
"appdetail.latest.release":`Latest Release`,
"appdetail.supported.terminals":`Supported Terminals`,
"appdetail.version":`Version`,
"appdetail.app.type":`Application Type`,
"appdetail.compatibility":`Compatibility`,
"appdetail.app.details":`Application Details`,
"appdetail.more.details":`More Details`,
"appdetail.more.from.provider":`More Products from Provider`,
"appdetail.provider.details":`Provider Details`,
"appdetail.pricing.details":`Pricing Details`,
"appdetail.payment.required":`You must pay to use this solution.`,
"appdetail.basic.version":`Basic Version`,
"appdetail.minimum.price":`Minimum Starting Price`,
"appdetail.provided.by":`Provided by {0}`,
"appdetail.cloudcc.industry.solution":`CloudCC Industry Solution`,
"message.no.matches.found":`We didn't find any matches Try a different search term.`,
"header.access.partner.crm":`18 years of deep cultivation, drawing on the experience of hundreds of ecosystem partners, to create specialized CRMs for 30 niche industries`,
"header.industry.demo": `No registration required! Instantly access the demo systems of 30 niche-industry CRMs and experience 100% real showcases of how AI and big data present industry know-how!`,
"header.login.your.crm":`Login to your CRM system`,
"appdetail.industry":`Industry`,
"appdetail.developer":`Developer`,
"appdetail.official.website":`Official Website`,
"appdetail.contact.email":`Contact Email`,
"appdetail.contact.phone":`Contact Phone`,
"appdetail.confirm.purchase":`Confirm Purchase?`,
"appdetail.tip":`Tip`,
"appdetail.confirm":`Confirm`,
"appdetail.cancel":`Cancel`,
"appdetail.purchase.success":`Purchase Successful`,
"appdetail.already.purchased":`You have already purchased this product`,
"appdetail.limited.time.free":`Limited Time Free`,
"appdetail.ai.building.solution":`AI is building a solution for you`,
"appdetail.build.failed":`Build Failed`,
"appdetail.ai.building.env":`AI is building a trial environment for you. Once completed, you will automatically enter the environment, and your email will receive login information.`,
"appdetail.ai.building.estimate":`Estimated: 2 to 10 minutes to complete`,
"appdetail.build.problem":`There was a problem during the build process. Please retry or contact customer service`,
"appdetail.building":`Building...`,
"appdetail.rebuild":`Rebuild`,
"appdetail.trial.email.title":`Apply for Trial`,
"appdetail.trial.email.content":`Please enter your email address, which will be used to create a trial account. You will also receive login information via email`,
"appdetail.trial.email.placeholder":`Please enter email address`,
"appdetail.trial.email.validation.required":`Please enter email address`,
"appdetail.trial.email.validation.format":`Please enter a valid email format`,
"appdetail.trial.email.validation.exists":`This email already exists, please use another email`,
"appdetail.trial.email.exists":`This email already exists, please use another email`,
"appdetail.trial.email.check.failed":`Email verification failed, please try again`,
"appdetail.trial.email.success":`Email verification successful, trial information has been sent`,
"appdetail.trial.email.error":`Email verification failed, please try again`,
"label.appstore.priceNumber.jian":`Unit price * Quantity * (remaining time - discount month) = Amount`,
"label.appstore.payTime":`Payment Date`,
"label.appstore.industry":`Industry`,
"label.appstore.Premium.offer":`Order by year to acquire steep discount. purchase 5 year service with 20 months for free.`,
"label.appstore.nopay":`Unpaid`,
"label.appstore.readMore":`Read More`,
"label.appstore.prease.enter.emailAddress":`Please enter your email address.`,
"label.appstore.Compare.details":`Compare order details`,
"label.appstore.Version.upgrade":`Version Upgrade`,
"label.appstore.Request.form":`Request Form`,
"label.appstore.ordeDetail":`Items`,
"label.appstore.enter.correct.email":`Please enter the correct email address.`,
"label.appstore.function":`Features`,
"label.appstore.accountType":`Account Type`,
"label.appstore.Ordering.plan":`Plan`,
"label.appstore.cardCode":`Credit card code`,
"label.appstore.Not.yet.purchased":`You haven't made any purchases yet`,
"label.appstore.Order.now":`Purchase now`,
"label.appstore.Paymen.method":`Payment Method`,
"label.appstore.T&C":`Terms & Conditions`,
"label.appstore.Subtotal":`Subtotal`,
"label.appstore.One.year.discount":`One year discount`,
"label.appstore.TotalQuantity":`Total number`,
"label.appstore.PaidAmount":`Amount Paid`,
"label.appstore.Received":`We have received your request and we will contact your soon.`,
"label.appstore.Amount.proportion":`Calculate amount by proportion`,
"label.appstore.enterEms":`Please enter your postal code.`,
"label.appstore.terms":`Terms`,
"label.appstore.change":`Update`,
"label.appstore.place.order":`Submit Order`,
"label.appstore.Ordinary.account":`Ordinary account`,
"label.appstore.UntilMaturity":`{0} months amount until expiration date`,
"label.appstore.changeBilling":`Use my billing address as my credit card address.`,
"label.appstore.newly.added":`Add`,
"label.appstore.buyDuration":`Purchase Period`,
"label.appstore.change.payoptions":`Select a new payment option.`,
"label.appstore.redirect":`You will be redirected to a login page for payment or create a PayPal account and update the payment method.`,
"label.appstore.quickTime":`Oh! Time flies...`,
"label.appstore.enterSurname":`Please enter your last name.`,
"label.appstore.quantity":`Quantity`,
"label.Version.change.succeeded":`Version`,
"label.appstore.please.fill.city":`Please fill in the city.`,
"label.appstore.contact.phone":`+1 (800) 820-6983`,
"label.appstore.payment.method.other":`Other Payment Method`,
"label.appstore.buy.year.Discount4":`Purchasing of 4 years enjoys 14 months free`,
"label.appstore.Add.function":`Add Service Cloud's field service and customer service features to your Lightning.`,
"label.appstore.Insufficient.privileges":`Insufficient privileges.`,
"label.appstore.View.order":`View Orders`,
"label.appstore.FillQuantity":`Please continue after filling in the quantity`,
"label.appstore.ordernum":`Item`,
"label.appstore.Upgradeable":`Upgradeable`,
"label.appstore.Remaining.licenses":`Remaining Licenses`,
"label.appstore.Renewal.succeeded":`Renew successfully`,
"label.appstore.add.User":`Add User`,
"label.appstore.SeeMore":`View More`,
"label.appstore.payment.gateway":`Payment Gateway`,
"label.appstore.enter.VerificationCode":`Please enter the card verification code.`,
"label.appstore.renew":`Renew`,
"label.appstore.Terms.of.service":`Terms of Service`,
"label.appstore.Billing.updated":`Your billing address has been updated successfully and all future invoices relating to this address will use the new address.`,
"label.appstore.selectCity":`Please select your city.`,
"label.appstore.buy.year.Discount":`Purchasing of 1 years enjoys 2 months free`,
"label.appstore.AnnualOrder":`Purchase by year`,
"label.appstore.change.version":`Change Version`,
"label.appstore.EnjoyAuthority":`(Have sales cloud feature and assignee management rights)`,
"label.appstore.HideFeatures":`Hide Features & Add-ons`,
"label.appstore.please.select.time":`Please select time.`,
"label.appstore.idiot.proof":`Safe and Secured`,
"label.appstore.notPayment":`No Payment Methods Found`,
"label.appstore.Manage.subscriptions":`Manage all <a style="color: #075bd5" href="https://www.cloudcc.com/"> products </a> in one place. Once you purchased our products, find them here.`,
"label.appstore.buy.year.Discount5":`Purchasing of 5 years or above enjoys 20 months free`,
"label.appstore.usd.annu":`/user/month billed annually`,
"label.appstore.Transaction.rejection":`Your transaction has been declined. Please contact your bank for further details.`,
"label.appstore.upgrade":`Upgrade`,
"label.appstore.Go.to.order":`Go to order`,
"label.appstore.Amount .paid.now":`Amount to be paid now`,
"label.appstore.TransferOrder":`Transfer Order`,
"label.appstore.Remaining.duration":`Remaining Time`,
"label.appstore.orderId":`Order ID`,
"label.appstore.AfterAdding":`After Adding`,
"label.appstore.update":`Update`,
"label.appstore.corporate.name":`Company`,
"label.appstore.Please.renew":`Please renew your subscription in the system within one month before the expiration date, so as not to affect your normal use.`,
"label.appstore.go":`To`,
"label.appstore.FlagshipEdition":`Ultimate version`,
"label.appstore.productName":`Product Name`,
"label.appstore.continue1":`Continue`,
"label.appstore.back.crm":`Back to CRM`,
"label.appstore.term.of.validity":`Valid Period`,
"label.appstore.please.fill.MM":`Please enter MM`,
"label.appstore.Cancelled":`Cancelled`,
"label.appstore.click":`Click`,
"label.appstore.please.fill.country":`Please fill in the country.`,
"label.appstore.Application.recommendation":`Official App Recommendations`,
"label.appstore.user.month":`{0}/user/month`,
"label.appstore.TransactionIDs":`Trade ID`,
"label.appstore.nofindbBlling":`No Billing Address Found`,
"label.appstore.Use.other.methods":`Use other methods`,
"label.appstore.ViewOrderDetail":`View Order Details`,
"label.appstore.ApplicationVersion":`App Version`,
"label.select.country.first":`Please choose Country/Region first`,
"label.appstore.Successfully.ordered":`You have successfully purchased our standard version plan.`,
"label.appstore.operation":`Action`,
"label.appstore.licensesTotal":`Total Licenses`,
"label.appstore.enterName":`Please enter your first name.`,
"label.appstore.time.year":`Time (years)`,
"label.appstore.Receive.discount":`Purchase by year to get your great value.`,
"label.appstore.workTime":`8 hours - Monday to Friday`,
"label.appstore.Payment.failed":`Purchase payment failed.`,
"label.appstore.please.fill.YY":`Please enter YY`,
"label.appstore.Billing.information":`Billing Details`,
"label.appstore.UserMonth":`{}/user/month`,
"label.appstore.Wrong.mobile":`The mobile phone number format is incorrect.`,
"label.appstore.enddate":`End Date`,
"label.appstore.buy.products":`If you want to buy our products, please contact us.`,
"label.appstore.user":`User`,
"label.appstore.ems":`ZIP`,
"label.appstore.month":`MM`,
"label.appstore.charge":`Charge`,
"label.appstore.sign":`This is a computer-generated invoice, no signature is required.`,
"label.appstore.ConfirmOrder":`Confirm Order`,
"label.appstore.Address.and.others":`Billing Address & Other Info`,
"label.appstore.EnterpriseEdition":`Enterprise version`,
"label.appstore.buy.year.Discount3":`Purchasing of 3 years enjoys 9 months free`,
"label.appstore.years":`YYYY`,
"label.appstore.product":`Product`,
"label.appstore.payHistory":`Payment History`,
"label.appstore.addUser":`Add User`,
"label.appstore.city":`City`,
"label.appstore.Discount.months":`18 months discount`,
"label.appstore.duration":`Duration`,
"label.appstore.OrderDuration":`Purchase Period`,
"label.appstore.selectState":`Please select your province/municipality.`,
"label.appstore.enterEmail":`Please enter your email address.`,
"label.appstore.Description.text":`Description text`,
"label.appstore.startdate":`Start Date`,
"label.appstore.Subscription":`Paid`,
"label.appstore.payment":`Payment`,
"label.appstore.enter.phone":`Please enter your phone number.`,
"label.appstore.VerificationCode":`CVV`,
"label.appstore.updated.success":`Update Successfull`,
"label.appstore.invoicedate":`Invoice Date`,
"label.appstore.PurchaseDetails":`Purchase details`,
"label.appstore.Pro.rata.amount":`Proportional Amount`,
"label.appstore.countrys":`Country/Region`,
"label.appstore.Due.date":`Expiration Date`,
"label.appstore.Four.part.order":`Purchase CloudCC in 4 easy steps`,
"label.appstore.Order.succeeded":`You have successfully purchased.`,
"label.appstore.enter.company.name":`Please enter your company name.`,
"label.appstore.shipto":`Ship To`,
"label.appstore.tabpage.ok":`Confirm`,
"label.appstore.Select.country":`Please select your country/region.`,
"label.appstore.OrderingCenter":`Purchase Center`,
"label.appstore.usernumber":`Users`,
"label.appstore.enterPhone":`Please enter your phone number.`,
"label.appstore.sales.pricing.issues":`For sales and pricing questions`,
"label.appstore.Transaction.history":`Transaction History`,
"label.appstore.download.invoice":`Download Invoice`,
"label.appstore.please.fill.state":`Please fill in the state/province.`,
"label.appstore.addAccount":`Add Account`,
"label.appstore.user.number.price":`Number of Users * Unit Price`,
"label.appstore.name":`First Name`,
"label.appstore.Core.account":`No.of Users`,
"label.appstore.retry":`Retry`,
"label.appstore.buy.year.Discount2":`Purchasing of 2 years enjoys 5 months free`,
"label.appstore.Download":`Download`,
"label.appstore.months.a":`month`,
"label.appstore.DueDate.month":`Expiration date (month)`,
"label.appstore.RenewalQuantity":`Number of renewals`,
"label.appstore.continue":`Click the below button to proceed. You will be redirected to the PayPal website where you can log in or create a PayPal account and update your payment method.`,
"label.appstore.Environment.version":`Environment Version`,
"label.appstore.total":`Total Amount`,
"label.appstore.Early.renewal":`Your purchase period is {0} and the expiration date is {1}. Please renew your purchase in the system within one month before the expiration date, so as not to affect your normal use.`,
"label.appstore.please.enter.cvc":`Please enter CVC/CVV.`,
"label.appstore.security.policy":`Security Policy`,
"label.appstore.Change.details":`Change Details`,
"label.appstore.change.payment":`Change Payment Method`,
"label.appstore.dueonreceipt":`Due On Receipt`,
"label.appstore.correct.cardNumber":`Please enter your card number.`,
"label.appstore.Subscriber":`Purchaser`,
"label.appstore.whole":`All`,
"label.appstore.statess":`State/Province`,
"label.appstore.payment.method":`Payment Method`,
"label.appstore.selectYear":`Please select the year.`,
"label.appstore.desc":`Description`,
"label.appstore.Discount.severalYears":`Discount for {0}-year order`,
"label.appstore.please.enter.lastDate":`Please enter the expiration date.`,
"label.select.state.first":`Please choose Province/City first`,
"label.appstore.SeveralMonths":`{0} months`,
"label.appstore.Manage.sub":`Manage CloudCC CRM Purchases`,
"label.appstore.Functional.highlights":`Feature Highlights`,
"label.appstore.switch.pay":`All subsequent payments will be switched to the new payment method.`,
"label.appstore.due.date":`Due Date`,
"label.appstore.status":`Status`,
"label.appstore.Update.billing.details":`Update Billing Detail`,
"label.appstore.TransactionID":`Order ID:{0}`,
"label.appstore.View.help.page":`For more information, see the "Insufficient Permissions Error" help page.`,
"label.appstore.New.order":`New`,
"label.appstore.Privacy.policy":`Privacy Policy`,
"label.appstore.order.details":`Order Details`,
"label.appstore.enter.last.name":`Please enter your last name.`,
"label.isappstore":`The expiration date is`,
"label.appstore.Please.enter.your.name":`Please enter your name`,
"label.appstore.enter.a.name":`Please enter your first name.`,
"label.appstore.MonthlyFee":`months fee`,
"label.appstore.Expired":`Expired`,
"label.appstore.Ordering.history":`Order History`,
"label.appstore.Payment.transaction.No":`No.of Payment`,
"label.appstore.error":`Something went wrong`,
"label.appstore.version":`Version`,
"label.appstore.store.details":`Your Store Details`,
"label.appstore.Payment.method.updated":`Your payment method has been updated successfully and will be used for all new orders in the future.`,
"label.appstore.addressDetail":`Street Address`,
"label.appstore.Add.account":`Add user`,
"label.appstore.Authorization.required":`You need permission to access this page`,
"label.appstore.creditCard":`Credit Card`,
"label.appstore.amountPaid":`Amount Paid`,
"label.appstore.taxinvoice":`Tax Invoice#`,
"label.appstore.createTime":`Created Date`,
"label.appstore.Product.transactionID":`Product/Order ID`,
"label.appstore.Renewal.duration":`Renewal Period`,
"label.appstore.Amount.month":`Amount/Month`,
"label.appstore.pay.differen":`Or to continue the payment, you can pay with a different credit card or PayPal account.`,
"label.appstore.Monthly.user":`{0}/user/month`,
"label.appstore.display.address":`Once you have purchased any of our products, your billing address will be displayed here.`,
"label.appstore.quantity.unit":`Quantity-Unit`,
"label.appstore.onOrder":`Purchased`,
"label.appstore.amount.to.be.paic":`Total amount to be paid`,
"label.appstore.Actual.payment.month":`Actual payment months`,
"label.appstore.jine":`Amount`,
"label.appstore.Please.enter.your.email.address":`Please enter your email`,
"label.appstore.Number.partners":`No.of Partners`,
"label.appstore.Submit":`Submit`,
"label.appstore.Reserved.rights":`Corporation Pvt. Ltd. All Rights Reserved`,
"label.appstore.confirm":`Confirm`,
"label.appstore.SupportTerminal":`Support Terminal`,
"label.appstore.phone.num":`Phone Number`,
"label.appstore.orderinfo":`Order Information`,
"label.appstore.surname":`Last Name`,
"label.appstore.date":`Date`,
"label.appstore.delete":`Delete`,
"label.appstore.type":`Type`,
"label.appstore.state":`State`,
"label.appstore.unprice":`Unit Price`,
"label.appstore.cloudcc":`CloudCC Inc Corporation Pte Ltd`,
"label.appstore.contact.us":`Contact Us`,
"label.appstore.visit":`Visit CloudCC`,
"label.appstore.Purchased.products":`Purchased Products`,
"label.appstore.amounttt":`The amount is prorated`,
"label.appstore.please.enter.cardcode":`Please enter your credit card code.`,
"label.appstore.SeveralDays":`{0} days`,
"label.appstore.End.trial":`Your 30-day trial has ended. Now your account data is still reserved for 15 days, and can be easily resumed after purchase.`,
"label.appstore.email":`Email`,
"label.appstore.Quantity.used":`Used Licenses`,
"label.appstore.card.number":`Card Number`,
"label.appstore.phone":`Phone`,
"label.appstore.Offline.payment":`Offline Payment`,
"label.appstore.showFeatures":`Show Features & Add-ons`,
"label.appstore.contact.email":`support@cloudcc.com`,
"label.appstore.Thank.choice":`Thank you for choosing CloudCC`,
"label.appstore.continue.agree":`By proceeding, you agree to our `,
"label.appstore.Discount":`Discount`,
"label.appstore.Welcome.useCloudcc":`Welcome to CloudCC Store!`,
"label.appstore.Operation.succeeded":`Successful operation`,
"label.appstore.No.view.permission":`You do not have the required access right to view this page. If access is required, please contact the record owner or your administrator.`,
"label.appmarket.officialaddress":`Address`,
"label.appmarket.free":`Free`,
"label.appmarket.human":`Human resource`,
"label.appmarket.mobileterminal":`Support for Mobile`,
"label.appstore.password":`Password`,
"label.appstore.Please.enter.reason.extend":`Please enter the reason to entend trial`,
"label.appmarket.allversions":`All Editions`,
"label.appmarket.make":`Manufacturing`,
"label.appmarket.placeselect":`Select`,
"label.appmarket.ContactEmail":`Email`,
"label.appstore.Cancel.trial":`Cancel the Trial`,
"label.appmarket.Contact Number":`Tel`,
"label.appmarket.morepackage":`The developer offers more packages.`,
"label.appmarket.comment":`Reviews`,
"label.appmarket.partner":`Partner department`,
"label.appmarket.professional":`Professional`,
"label.appmarket.cooperativepartner":`Partners`,
"label.appmarket.other":`Others`,
"label.appstore.Cancellation.reason":`Reason for cancellation`,
"label.appmarket.automobile":`Car insurance`,
"label.appstore.Please.enter.reason.canceling":`Please enter the reason for canceling trial`,
"label.appmarket.crm":`A New CloudCC CRM Ecology`,
"label.appstore.length":`Length from 7 to 11 characters`,
"label.appmarket.appstore":`App Store`,
"label.appstore.AreYouSure.cancel.account":`Are you sure to cancel the CloudCC account?`,
"label.appmarket.IT":`IT`,
"label.appmarket.edu":`Education`,
"label.appstore.version.enterprise":`ENTERPRISE +`,
"label.appstore.Extended.use":`Extend Trial`,
"label.appmarket.launchtime":`Date of launch`,
"label.appmarket.medical":`Medical`,
"label.appmarket.pay":`Paid`,
"label.appmarket.solution":`Solutions`,
"label.appmarket.eliminate":`Clear`,
"label.appmarket.allprices":`All Plans`,
"label.appstore.Extended.trial":`Extend the Trial`,
"label.appmarket.lastrelease":`Latest`,
"label.appstore.website.aboutus.officecall":`Call:`,
"label.appmarket.office":`Office Cloud`,
"label.appmarket.setuptime":`Date of establishment`,
"label.appstore.expired2":`Your trail has expired`,
"label.appstore.extensionSuccess":`Congratulations! Your trial has been extended by 15 days. You will be redirected to the homepage.`,
"label.appstore.Upgrade.payment":`We hope you have fully experienced the features during the trial period. To continue using CloudCC, please upgrade to the paid version.`,
"label.appmarket.viewall":`View all`,
"label.appmarket.market":`Marketing Cloud`,
"label.appmarket.unlimited":`Unlimited`,
"label.appmarket.versionno":`Build number`,
"label.appmarket.industry":`Industries`,
"label.appstore.Cancel.account":`This operation will cancel your CloudCC account and the existing CloudCC data will be migrated to the free version of the CRM application.`,
"label.appmarket.sales":`Sales Cloud`,
"label.appmarket.apply":`Apply`,
"label.appmarket.packagecontent":`Package contents`,
"label.appstore.CancelCC":`Cancel My CloudCC Account`,
"label.appstore.Please.enter.password":`Please enter the password`,
"label.appstore.experience":`Please tell us about your experience with CloudCC here and we will extend your trial period by 15 days.`,
"label.appstore.version.free":`BASIC +`,
"label.appstore.least.one":`Please purchase at least one license as the CloudCC Administrator.`,
"label.appmarket.allratings":`See all`,
"label.appstore.Dont.continue":`Don't want to continue using CloudCC?`,
"label.appmarket.finance":`Finance`,
"label.appmarket.applications":`Applications`,
"label.appstore.time.expand":`Need more time to explore these features?`,
"label.appmarket.computerterminal":`Support for Web`,
"label.appmarket.obtain":`Get`,
"label.appmarket.components":`Components`,
"label.appstore.actualDuration":`Months after Discount`,
"label.appmarket.score":`Ratings`,
"label.appmarket.service":`Service Cloud`,
"label.appmarket.for":`Apply to`,
"label.appmarket.project":`Project management`,
"label.appstore.Storetitle":`CloudCC Store`,
"label.appmarket.summary":`Overview`,
"label.appstore.version.professional":`PROFESSIONAL +`,
"label.appstore.three.part.order":`Purchase CloudCC in 3 easy steps`,
"resource.industry.logistics": `Logistics Industry`,
"resource.error.get.user.info": `Failed to get user information`,
"resource.warning.get.user.info.tips": `Please complete your basic personal information.`,
"resource.app.store.title": `Personal Center`,
"resource.success": `SUCCESS`,
"resource.success.demo.apply": `Demo Application Successful`,
"label.account.reg.fail.msg":`Registration failed, please try again later.`,
"resource.industry.ecommerce":`E-commerce`,
"resource.industry.system.integration":`System Integration`,

// Personal page related
"personal.tab.basic.info": "Basic Information",
"personal.tab.account.info": "Account Information",
"personal.tab.my.company": "My Company",
  "personal.edit": "Edit",
  "personal.new.company": "New Company",
  "personal.current.company": "Current Company",

// Basic information fields
"personal.field.avatar": "Avatar",
"personal.field.name": "Name",
"personal.field.qq": "QQ Number",
"personal.field.wechat": "WeChat",
"personal.field.phone": "Contact",
"personal.field.region": "Region",
"personal.field.company.size": "Company Scale",
"personal.field.industry": "Industry",
"personal.field.title": "Position",
"personal.field.num.of.users": "Users",
"personal.field.launch.date": "Launch Date",
"personal.field.pain.point": "Pain Points",
"personal.field.budget": "Budget",
"personal.field.language": "Language",

// Account information fields
"personal.field.login.account": "Login Account",
"personal.field.password": "Password",
"personal.field.mobile": "Mobile",
"personal.field.email": "Email",

// Company size options
"personal.company.size.less.than.20": "Less than 20 employees",
"personal.company.size.21.100": "21-100 employees",
"personal.company.size.101.500": "101-500 employees",
"personal.company.size.501.1000": "501-1000 employees",
"personal.company.size.more.than.1000": "More than 1000 employees",

// Position options
"personal.title.sales.manager": "Sales Manager",
"personal.title.marketing.hr.manager": "Marketing/HR Manager",
"personal.title.customer.service.manager": "Customer Service Manager",
"personal.title.general.manager": "General Manager",
"personal.title.it.manager": "IT Manager",
"personal.title.operations.manager": "Operations Manager",
"personal.title.other": "Other",

// EditBasicInfo page related
"personal.edit.basic.info": "Complete Basic Information",
"personal.cancel": "Cancel",
"personal.save": "Save",

// Placeholder text
"personal.placeholder.name": "Please enter name",
"personal.placeholder.qq": "Please enter QQ number",
"personal.placeholder.wechat": "Please enter WeChat",
"personal.placeholder.phone": "Please enter contact information",
"personal.placeholder.region": "Please select province/city/county",
"personal.placeholder.company.size": "Please select company size",
"personal.placeholder.industry": "Please enter industry",
"personal.placeholder.title": "Please select position",
"personal.placeholder.num.of.users": "Please enter expected number of CRM users",
"personal.placeholder.launch.date": "Please select launch date",
"personal.placeholder.pain.point": "Please enter pain points (optional)",
"personal.placeholder.budget": "Please enter budget (optional)",

// Validation messages
"personal.validation.avatar.required": "Please upload avatar",
"personal.validation.name.required": "Please enter name",
"personal.validation.phone.required": "Please enter contact information",
"personal.validation.region.required": "Please select region",
"personal.validation.company.size.required": "Please select company size",
"personal.validation.industry.required": "Please enter industry",
"personal.validation.title.required": "Please select position",
"personal.validation.num.of.users.required": "Please enter number of users",
"personal.validation.launch.date.required": "Please select expected launch date",

// Message prompts
"personal.message.save.success": "Basic information saved successfully",
"personal.message.save.failed": "Save failed, please try again",
"personal.message.complete.required": "Please complete required information",

// Avatar related
"personal.avatar.title": "Personal Avatar",
"personal.avatar.description": "Upload your personal avatar, supports JPG, PNG, GIF formats, file size not exceeding 5MB",
"personal.avatar.upload": "Upload Avatar",
"personal.avatar.uploading": "Uploading...",
"personal.avatar.remove": "Remove Avatar",
"personal.avatar.remove.title": "Confirm Removal",
"personal.avatar.remove.confirm": "Are you sure you want to remove the current avatar?",
"personal.avatar.remove.success": "Avatar removed successfully",
"personal.avatar.upload.success": "Avatar uploaded successfully",
"personal.avatar.upload.failed": "Avatar upload failed",
"personal.avatar.error.invalid.type": "Please select JPG, PNG or GIF format image",
"personal.avatar.error.too.large": "Image size cannot exceed 5MB",
"personal.avatar.tips": "Supports JPG, PNG, GIF formats, file size not exceeding 5MB",
"personal.confirm": "Confirm",

// modifyContact.vue related terms
"personal.modify.mobile.title": "Modify Mobile",
"personal.modify.email.title": "Modify Email",
"personal.placeholder.mobile": "Please enter mobile number",
"personal.placeholder.email": "Please enter email",
"personal.validation.mobile.required": "Please enter mobile number",
"personal.validation.email.required": "Please enter email",
"personal.validation.mobile.format": "Please enter a valid mobile number",
"personal.validation.email.format": "Please enter a valid email",
"personal.message.mobile.save.success": "Mobile number updated successfully",
"personal.message.email.save.success": "Email updated successfully",
"personal.message.mobile.duplicate": "Mobile number is already in use, please use another one",
"personal.message.complete.info": "Please complete the information",

// modifyPassword.vue related terms
"personal.modify.password.title": "Modify Password",
"personal.field.old.password": "Current Password",
"personal.field.new.password": "New Password",
"personal.field.confirm.password": "Confirm Password",
"personal.placeholder.old.password": "Please enter current password",
"personal.placeholder.new.password": "Please enter new password",
"personal.placeholder.confirm.password": "Please confirm new password",
"personal.validation.old.password.required": "Please enter current password",
"personal.validation.new.password.required": "Please enter new password",
"personal.validation.confirm.password.required": "Please confirm new password",
"personal.validation.password.length": "Password must be 6-20 characters",
"personal.validation.password.mismatch": "Passwords do not match",
"personal.message.password.save.success": "Password updated successfully",
"personal.message.password.save.failed": "Password update failed, please try again",
"allApps.add.filter":`Add Filter`,
"allApps.show.results.filter":`Showing {0} results, filter conditions`,
"allApps.search.filter.placeholder":`Search filters...`,
"applist.all.results":`All Results`,
// Route titles
"route.title.home":`Home`,
"route.title.industry.mall":`Industry Mall`,
"route.title.app.detail":`App Detail`,
"route.title.my.apps":`My Apps`,
"route.title.my.apps.detail":`My App Detail`,
"route.title.partnership":`Partnership`,
"route.title.invoice.management":`Invoice Management`,
"route.title.create.invoice":`Create Invoice`,
"route.title.invoice.detail":`Invoice Detail`,
"route.title.personal.center":`Personal Center`,
"route.title.app.list":`App List`,
"route.title.page.not.found":`Page Not Found`,
// Trial page
"trial.page.title": "Start Trial",
"trial.step1": "Step 1",
"trial.step2": "Step 2",
"trial.step1.title": "You will try the following features",
"trial.features.experience": "Experience in your test environment",
"trial.features.full.solution": "Complete business solution",
"trial.features.powerful.paas": "Powerful PaaS platform capabilities",
"trial.features.build.app": "Build your own application",
"trial.features.experience.crm": "Experience CRM system",
"trial.features.experience.portal": "Experience customer portal",
"customer.portal.crm.integration": "Customer portal with CRM data integration",
"industry.portal.mall": "Industry-standard customer portal or mall",
"fully.integrated.crm": "Fully integrated with CRM",
"customizable.details": "Customizable details based on your requirements",
"trial.cta.experience.now": "Experience Now",
"trial.step2.title": "Share your contact information",
"trial.step2.helper": "Please enter your contact details. After submitting, AI will create a trial environment for you. To keep it available, check your email within 3 days and change the initial password, otherwise AI will reclaim the environment.",
"trial.form.first.name": "First Name",
"trial.form.last.name": "Last Name",
"trial.form.email": "Email",
"trial.form.email.placeholder": "Required, used to receive account and password",
"trial.form.company": "Company",
"trial.form.title": "Title",
"trial.form.staff": "Employees",
"trial.form.phone": "Mobile",
"trial.form.country.region": "Country/Region",
"trial.form.agree.privacy": "By submitting you agree to and have read CloudCC Privacy Policy",
"trial.form.agree.prefix": "By submitting, you agree and have read",
"label.account.pleaseAgree": "Please agree to terms of service and privacy policy",
"trial.contact.website": "Website",
"trial.contact.email": "Email",
"trial.contact.phone": "Phone",
"trial.cta": "Try Now",
"email.check.verification.code": "Check your email for the verification code",
"email.send.verification.code": "Send Verification Code",
"email.fill.verification.code": "Please enter the email verification code",
"email.verification.sent": "Verification code sent, please check your email",
"email.resend.after.seconds": "Resend in {0}s",
"email.verification.send.failed": "Failed to send verification code, please try again",
"trial.disclaimer": "CloudCC is not the provider of this solution, but has conducted limited security review.",
"label.account.please.enter.name": "Please enter last name",
"label.account.username.enter": "Please enter first name",
"label.account.enter.Emailbox": "Please enter email address",
"label.account.batchadd.newbatchpage.save.em": "Invalid email format",
"label.account.Company.name": "Please enter company name",
"label.account.fillMobile": "Please enter phone number",
"label.account.only.Numbers": "Only digits are allowed",
"label.account.phone.length": "Phone number must be at least 7 digits",
"label.account.reg.phone.already": "This phone number is already registered under this company",
"label.account.Select.job": "Please select title",
"label.account.Select.staff": "Please select staff size",
"label.account.Select.country": "Please select country/region",
"personal.placeholder.language": "Please select language",
}